import React, { useEffect, createElement } from 'react';
import { SITE_IMAGES } from '../components/siteImages';
import { KidsHeroInfo } from './kids-classes/KidsHeroInfo';
import { KidsHeroForm } from './kids-classes/KidsHeroForm';
import { KidsAgeGroups } from './kids-classes/KidsAgeGroups';
import { KidsMiniTroopers } from './kids-classes/KidsMiniTroopers';
import { KidsStormTroopers } from './kids-classes/KidsStormTroopers';
import { KidsConfidence } from './kids-classes/KidsConfidence';
import { KidsFitness } from './kids-classes/KidsFitness';
import { KidsRespect } from './kids-classes/KidsRespect';
import { KidsReviews } from './kids-classes/KidsReviews';
import { KidsClassTimes } from './kids-classes/KidsClassTimes';
import { KidsFAQHeader } from './kids-classes/KidsFAQHeader';
import { KidsFAQQuestions } from './kids-classes/KidsFAQQuestions';
import { KidsRelatedLinks } from './kids-classes/KidsRelatedLinks';
import { KidsFinalCTA } from './kids-classes/KidsFinalCTA';
export function KidsClasses() {
  useEffect(() => {
    document.title = 'Kids Taekwondo & Martial Arts Classes in Farmington Hills | Storm Taekwondo';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Storm Taekwondo helps kids in Farmington Hills build confidence, discipline, focus, and real Taekwondo skills. Mini Troopers ages 3-5 and Kids Taekwondo ages 6+. Start a trial class.';
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-2272">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-2273">
        <div className="absolute inset-0 opacity-25" data-id="element-2274">
          <img src={SITE_IMAGES.kidsClasses} alt="Kids Taekwondo class at Storm Taekwondo Farmington Hills" className="block w-full h-full object-cover" data-id="element-2275" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-2276" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2277">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-2278">
            <KidsHeroInfo data-id="element-2279" />

            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-2280">
              <KidsHeroForm data-id="element-2281" />
            </div>
          </div>
        </div>
      </section>
      <KidsAgeGroups data-id="element-2282" />
      <KidsMiniTroopers data-id="element-2283" />
      <KidsStormTroopers data-id="element-2284" />
      <KidsConfidence data-id="element-2285" />
      <KidsFitness data-id="element-2286" />
      <KidsRespect data-id="element-2287" />
      <KidsReviews data-id="element-2288" />
      <KidsClassTimes data-id="element-2289" />
      <section className="py-24 bg-off-white" data-id="element-2290">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2291">
          <KidsFAQHeader data-id="element-2292" />
          <KidsFAQQuestions data-id="element-2293" />
        </div>
      </section>
      <KidsRelatedLinks data-id="element-2294" />
      <KidsFinalCTA data-id="element-2295" />
    </div>;
}